import { alpha, useTheme } from '@mui/material';
import type { Theme } from '@mui/material/styles';

export const chartSurface = (theme: Theme) => ({
  grid:
    theme.palette.mode === 'dark'
      ? alpha(theme.palette.common.white, 0.08)
      : theme.palette.divider,
  axis: theme.palette.text.secondary,
  tooltip: {
    backgroundColor: theme.palette.background.paper,
    border: `1px solid ${theme.palette.divider}`,
    color: theme.palette.text.primary,
    borderRadius: 8,
    boxShadow: theme.shadows[3],
  },
});

export const useChartSurface = () => {
  const theme = useTheme();
  return chartSurface(theme);
};

export const timelineWash = (theme: Theme, color: string, strength = 0.18) =>
  alpha(color, theme.palette.mode === 'dark' ? Math.min(strength + 0.1, 0.32) : strength);

export const trackBackground = (theme: Theme) =>
  theme.palette.mode === 'dark'
    ? alpha(theme.palette.common.white, 0.06)
    : alpha(theme.palette.common.black, 0.05);
